import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

export const getCommonQuizTopicThunk = createAsyncThunk(
  "commonquiz/get",
  async (params) => {
    const { usertype } = params;
    let response = await api.get("getMasterTtlQuizTopicsData/" + usertype +"/" + "teacher" +"/" + "od");
    return response.data;
  }
);

export const createCommonQuizTopicThunk = createAsyncThunk(
  "commonquiz/create",
  async (body) => {
    let response = await api.post("saveMasterTtlQuizTopic ", body);
    return response.data;
  }
);

export const updateCommonQuizTopicThunk = createAsyncThunk(
  "commonquiz/update",
  async (reqbody) => {
    const id = reqbody._id;
    const { _id, ...body } = reqbody; // remove _id from reqbody and create new object called body

    let response = await api.put("updateMasterTtlQuizTopic/" + id, body.body);
    return response.data;
  }
);

export const deleteCommonQuizTopicThunk = createAsyncThunk(
  "commonquiz/delete",
  async (data) => {
    let response = await api.delete(`deleteMasterTtlQuizTopic/${data.topicId}`);
    return response.data;
  }
);











